import { Suspense, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { deleteItem, fetchPaginationData } from "../../utils/apiUtils";
import DeleteModel from "../../Components/DeleteModel";
import Spinner from "../../Components/spinner";
import Breadcrumb from "../../Components/Breadcrumb";
import Pagination from "../../Components/Pagination";
import { ActionButton, PlusButton } from "../../Components/TableHelper";

const EmailTemplate = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [deleteItemId, setDeleteItemId] = useState({});
  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [perPage] = useState(10);
  const navigator = useNavigate();

  const fetchDataPagination = async (page = 1) => {
    const requestData = {
      perPage: perPage,
      pageNo: page,
    };
    await fetchPaginationData(
      "emailtemplate/emailtemplate-pagination",
      requestData,
      setData,
      setTotalCount,
      setCurrentPage,
      setLoading,
    );
  };

  useEffect(() => {
    fetchDataPagination();
  }, []);

  const totalPages = Math.ceil(totalCount / perPage);
  const handlePageClick = (page) => {
    if (page >= 1 && page <= totalPages) {
      fetchDataPagination(page);
    }
  };

  const handleDelete = async (data) => {
    setDeleteItemId(data);
    setDeleteModalOpen(true);
  };

  const confirmDelete = async () => {
    setIsDeleting(true);
    try {
      const res = await deleteItem(
        "deleteemailtemplate",
        deleteItemId?._id,
        fetchDataPagination,
      );
      setDeleteItemId({});
      setDeleteModalOpen(false);
      return res;
    } catch (error) {
      return error;
    } finally {
      setIsDeleting(false);
    }
  };

  const handleAdd = () => {
    navigator("/add-email-template", { state: { sortOrder: data.length + 1 } });
  };
  const handleEditClick = (item) => {
    navigator("/add-email-template", {
      state: item,
    });
  };

  const Tableheader = ["Template Name", "Subject", "Action"];

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Email Templates", path: "*" },
  ];

  return (
    <>
      <div className="content-wrapper">
        <div className="page-header">
          <h3 className="custom-page-title">Email Templates</h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div
          className="d-flex justify-content-end bg-white p-2 mt-n2"
          style={{ gap: 5 }}
        >
          <PlusButton handleAdd={handleAdd} module={"Services"} />
        </div>
        <div className="row" style={{ marginTop: "10px" }}>
          <div className="col-md-12 ">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  <table
                    className="custom-table table table-striped"
                    id="slidertable"
                  >
                    <thead>
                      <tr>
                        <th className="font-weight-bold">#</th>
                        {Tableheader.map((item, index) => (
                          <th className="font-weight-bold" key={index}>
                            {item}
                          </th>
                        ))}
                      </tr>
                    </thead>

                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="12" className="text-center">
                            <Spinner />
                          </td>
                        </tr>
                      ) : data?.length > 0 ? (
                        data.map((item, index) => (
                          <tr key={item?._id}>
                            <td>{index + 1}</td>
                            <td>{item.name}</td>
                            <td>{item.subject}</td>
                            <td>
                              <ActionButton
                                data={item}
                                handleEditClick={handleEditClick}
                                handleDelete={handleDelete}
                                module="emailTemplate"
                              />
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="12" className="text-center">
                            <h5>No data found.</h5>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {data?.length > 0 && (
                  <div>
                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      onPageChange={handlePageClick}
                      perPage={perPage}
                      totalCount={totalCount}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {deleteModalOpen && (
        <Suspense fallback={null}>
          <DeleteModel
            deleteModalOpen={deleteModalOpen}
            setDeleteModalOpen={() => setDeleteModalOpen(!deleteModalOpen)}
            onConfirm={confirmDelete}
            itemName="email template"
            isDeleting={isDeleting}
          />
        </Suspense>
      )}
    </>
  );
};

export default EmailTemplate;
